// extracted by mini-css-extract-plugin
module.exports = {"description":"LAndRCountries_description__GCjaW"};